module.exports = __webpack_public_path__ + "img/contribs.75e4dbe5.png";